$('.mrk-create-perfume').click(function (e) { 
    e.preventDefault();
    $('create-product-drawer').html(window.mrkPopupContent);
    initMainSlider();
    bindEvents();
    handleChangeEvent();
    handleVariantChange();
    document.querySelector('create-product-drawer').show();
    window.mrkCustomClick = true;
    $('.mrk-first-perfume input').prop('checked',true).trigger('change');
    getBrands();
    setTimeout(function(){
        window.mrkCustomClick = false;
    },2000)
});
function slideAnimation($element, outClass, callback) {
    $element.addClass(outClass).animate(outClass, function () {
        $element.addClass('step-hide').removeClass(outClass);
        callback();
    });
}
function bindEvents(){
    initSearch();
    initSelect();
}
function moveTo(e) {
    $('html, body').animate({
        scrollTop: $(e).offset().top - 200
    }, 500);
}
function initMainSlider(){
    $('media-carousel-mrk').slick({
        dots: false,
        infinite: false,
        loop: false,
        autoplay: false,
        arrows: false,
        fade:true,
        draggable:false,
        swipeToSlide: false,
        rtl: rtl,
        touchMove: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
    });
}
function initSearch() {
    // Handle input event with delegation
    $('.mrk-search-bar input').unbind('input');
    $('.mrk-search-bar input').on('input', function() {
        const searchValue = $(this).val().toLowerCase();
        const linkList = $(this).parents('.mrk-custom-dropdown').find('.option-list li');
        console.log(searchValue.length, $(this));

        if (searchValue.length === 0) {
            linkList.show();
            return;
        }
        linkList.each(function() {
            const linkText = $(this).text().toLowerCase();
            linkText.includes(searchValue) ? $(this).show() : $(this).hide();
        });
    });
}
function renderBrandProducts(li){
    var url = $(li).attr('value');
    var selector = $(li).parents('.mrk-brand-fragrance').find('.model-select');
    if(window.selectedBrand != undefined && window.selectedFragrance){
      getData(url,selector,mrkautoSelectFragrance);
    }else{
      getData(url,selector);
    }
}
function mrkautoSelectFragrance(){
  if(window.selectedBrand != undefined && window.selectedFragrance){
    var toSelectFragrance = $(`.mrk-active-create .selectbottledesign li[value="${window.selectedFragrance}"]`);
    if($(toSelectFragrance).length == 0){
        $('.mrk-info-about-product').html(`${window.selectedFragrance} not Available!`).removeClass('mrk-loading')
        setTimeout(() => {
            $('.mrk-info-about-product').addClass('mrk-loading')
        }, 3000);
    }else{
        setTimeout(function(){
        var toSelectFragrance = $(`.mrk-active-create .selectbottledesign li[value="${window.selectedFragrance}"]`);
        console.log(toSelectFragrance);
        $(toSelectFragrance).click();
        window.selectedBrand = undefined;
        window.selectedFragrance = undefined;
        },200)
    }
  }
}
function initSelect(){
    $('.mrk-selected-option').unbind('click');
    $('.mrk-custom-dropdown li').unbind('click');
    $('.mrk-selected-option').click(function (e) { 
        e.preventDefault();
        $(this).parents('.mrk-custom-dropdown').find('.dropdown-wrapper').slideToggle('fast');
        $(this).parents('.mrk-custom-dropdown').find('.mrk-search-bar-input').focus()
    });
    $('.mrk-custom-dropdown li').click(function (e) {
        $(this).parents('.dropdown-wrapper').slideUp('fast');
        var value = $(this).attr('value');
        var text = $(this).text();
        var name = $(this).attr('name');
        var variantId = $(this).attr('variantId');
        var productVariants = $(this).attr('productVariants');
        var price = $(this).attr('price');
        var fragrance = $(this).attr('fragrance');
        $(this).parents('.mrk-custom-dropdown').find('.selected-value').text(text).attr('value', value).attr('variantId',variantId).attr('name',name).attr('price',price).attr('productVariants',productVariants).attr('fragrance',fragrance);
        if($(this).parents('.mrk-custom-dropdown').hasClass('selectbottlebrand')){
            renderBrandProducts($(this))
        }
        if($(this).parents('.mrk-custom-dropdown').hasClass('mrk-final-product-list')){
            if($('[data-option-selector]').length)
            $('[data-option-selector]')[1].dispatchEvent(new Event('change',{}));
        }
        enableFinalAddToCart();
    });
    $(document).click(function(e) {
        if (!$(e.target).closest('.mrk-custom-dropdown').length) {
            $('.dropdown-wrapper').slideUp('fast');
        }
    });
}
function enableFinalAddToCart() {
    const BrandLength = $('.mrk-active-create .selectbottlebrand .selected-value[value]').length;
    const checkedLength = $('.mrk-active-create .mrk-final-product-list .selected-value[value]').length;
    const isDisabled = checkedLength && BrandLength;
    if(isDisabled){
        UpdateVariantId();
        $('.mrk-create-info').slideDown();
    }
    else{
        $('.mrk-create-info').slideUp();
    }
    var title = $('.mrk-active-create .mrk-final-product-list .selected-value[value]').attr('value');
    var subTitle = $('.mrk-feature-create [name="option1"]:checked').val();
    if($('[name="mrk-perfume-type"]:checked').val() == 'parfum')
      $('.mrk-select-product-title').html(title+ ' / ' + subTitle);
    else
      $('.mrk-select-product-title').html(title);
    $('#createAddToCart').toggleClass('disabled', !isDisabled);
}
function getData(url,selector,callback){
    var callback = callback || function() { };
    $.ajax({
        type: "GET",
        url,
        dataType: "html",
        cache: true,
        beforeSend: function(){
            $(selector).html(`<div class="mrk-loader"><div class="lds-dual-ring"></div></div>`).addClass('mrk-loading');
        },
        success: function (response) {
            selector.html(response).removeClass('mrk-loading');
            callback();
            bindEvents();
        }
    });
}
function onChangeClick(){
    $('.mrk-info-about-product').addClass('mrk-loading');
    var _id = $('[name="mrk-perfume-type"]:checked').attr('id');
    var hasBottleSelection = false;
    if($('[name="mrk-perfume-type"]:checked').attr('hasbottleselection') == 'true')
    hasBottleSelection = true;
    if(hasBottleSelection == true){
        if(window.mrkCustomClick){
            var element = $('[mrk-preselected][name="option1"]');
            element.prop('checked', true);
            if($('[data-option-selector]').length)
            $('[data-option-selector]')[1].dispatchEvent(new Event('change',{}));
        }else{
            slideAnimation($('.mrk-step-1-create-perfume'), 'slideOutLeft', () => {
                $('.mrk-step-2-create-perfume').removeClass('step-hide').addClass('slideInRight');
                $('media-carousel-mrk').slick('refresh');
                var element = $('[mrk-preselected][name="option1"]');
                element.prop('checked', true);
                if($('[data-option-selector]').length)
                $('[data-option-selector]')[1].dispatchEvent(new Event('change',{}));
            });
            setTimeout(function(){
                $('.mrk-step-2-create-perfume').removeClass('animated');
            },1500);
        }
    }
    var title = $('.mrk-active-create .mrk-final-product-list .selected-value[value]').attr('value');
    window.selectedBrand = $('.mrk-active-create .selectbottlebrand .selected-value[value]').attr('name');
    if(window.selectedFragrance == undefined)
    window.selectedFragrance = $('.mrk-active-create .mrk-final-product-list .selected-value[value]').attr('value');
    $('.mrk-brand-fragrance').removeClass('mrk-active-create');
    $(`.mrk-brand-fragrance[for="${_id}"]`).addClass('mrk-active-create');
    // console.log(window.selectedBrand,window.selectedFragrance);
    if(window.selectedBrand != undefined && window.selectedFragrance){
        $(`.mrk-active-create .selectbottlebrand li[name="${window.selectedBrand}"]`).click();
    }
    $('.mrk-brand-fragrance.mrk-active-create').removeClass('disabled');
    $('.mrk-final-add-to-cart-create').removeClass('disabled');
    $('.mrk-brands-and-frangrance-wrap').removeClass('disabled');

    enableFinalAddToCart();
}
function handleChangeEvent(){
    $('[name="mrk-perfume-type"]').change(function (e) {
        e.preventDefault();
        onChangeClick()
    });
    $('.mrk-first-perfume').click(function (e) {
        $('.mrk-first-perfume input').prop('checked',true).trigger('change');
    });
    $('.mrk-back-btn').click(function (e) { 
        e.preventDefault();
        // $('[name="mrk-perfume-type"]:checked').prop('checked', false);
        var title = $('.mrk-active-create .mrk-final-product-list .selected-value[value]').attr('value');
        var subTitle = $('.mrk-feature-create [name="option1"]:checked').val();
        if(title != undefined)
        $('.mrk-select-product-title').html(title + ' / ' + subTitle);
        $('.mrk-step-2-create-perfume').addClass('animated');
        slideAnimation($('.mrk-step-2-create-perfume'), 'slideOutRight', () => {
            $('.mrk-step-1-create-perfume').removeClass('step-hide').addClass('slideInLeft');
        });
    });
}
function handleVariantChange(){
    $('.mrk-feature-create [name="option2"]').change(function (e) { 
        const imageToChange = $('.mrk-feature-create [name="option2"]:checked').attr('mrkimage');
        if(imageToChange != undefined){
            var slideIndex = Number($(`media-carousel-mrk [imagefor="${imageToChange}"]`).attr('data-slick-index'));
            $('media-carousel-mrk').slick('slickGoTo', slideIndex);
        }
        setTimeout(UpdateVariantId,100);
    });
}
function addMetaData(){
    var products_names = '';
    $('.mrk-active-create .mrk-final-product-list').each(function(index,item) {
        var title = $(this).find('.selected-value').attr('value');
        var item = `<input type="hidden" name="properties[${index+1}]" value="${title}">`;
        products_names = products_names + item;
    });
    $('.mrk-custom-attributes').html(products_names);
}
function UpdateVariantId(){
    var variantId = $('.mrk-active-create .mrk-final-product-list .selected-value[value]').attr('variantId');
    var title = $('.mrk-active-create .mrk-final-product-list .selected-value[value]').attr('value');
    var subTitle = $('.mrk-feature-create [name="option1"]:checked').val();
    var price = $('.mrk-active-create .mrk-final-product-list .selected-value[value]').attr('price');
    var selected_Product = $('[name="mrk-perfume-type"]:checked').attr('productName');
    var fragrance = $('.mrk-active-create .mrk-final-product-list .selected-value[value]').attr('fragrance');
    var productVariants = $('.mrk-active-create .mrk-final-product-list .selected-value[value]').attr('productVariants');
    if($('[name="mrk-perfume-type"]:checked').attr('hasbottleselection') == 'true')
    UpdateVariantsMultiple(productVariants);
    if(title != undefined)
    $('.mrk-select-product-title').html(title);
    if($('[name="mrk-perfume-type"]').val() == 'parfum')
    $('.mrk-select-product-title').html(title+ ' / ' + subTitle);
    $('.mrk-selected-product-price').html(price+ ' / ' + selected_Product);
    $('.mrk-create-info-title').html(fragrance);
    $('.mrk-final-add-to-cart-create [name="id"]').val(variantId);
}
function UpdateVariantsMultiple(productVariants){
    var variants = JSON.parse($(productVariants).html());
    var value1 = $('.mrk-feature-create [name="option1"]:checked').val().toLowerCase().replace('bottle', ''); //.replace('bottle', '')
    var value2 = $('.mrk-feature-create [name="option2"]:checked').val().toLowerCase().replace('bottle', ''); //.replace('bottle', '')
    if(!(value1.includes('100') || value2.includes('100'))){
      value1 = value1.replace('default', '');
      value2 = value2.replace('default', '')
    }
    variants.forEach(function(variant){
        var title = variant.title.toLowerCase().replace('bottle', ''); //.replace('default', '')
        if(!title.includes('100'))
          title = title.replace('default', '');
        if(title.includes(value1) && title.includes(value2) && variant.option1.toLowerCase() == 'perfume'){
            console.log(title,'---',value1, '-', value2);
            setTimeout(function(){
                $('.mrk-final-add-to-cart-create [name="id"]').val(variant.id);
                var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
                var price = window.formatMoney(variant.price,currencyFormat)
                $('.mrk-selected-product-price').html(price);
            },1)
            return;
        }
    })
}
function getBrands(){
  $('.mrk-brands-list').each(function(){
    var _this = $(this);
    var url = $(this).attr('url');
    $.ajax({
        type: "GET",
        url,
        dataType: "html",
        cache: true,
        success: function (response) {
            console.log(response);
            $(_this).html(response);
            bindEvents();
        }
    });
  });
}
initMainSlider();
bindEvents();
handleChangeEvent();
handleVariantChange();
